import { render, staticRenderFns } from "./ktv.vue?vue&type=template&id=5da9b6ae&"
import script from "./ktv.vue?vue&type=script&lang=js&"
export * from "./ktv.vue?vue&type=script&lang=js&"
import style0 from "./ktv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports